import { useEffect, useState } from 'react';
import { getTelemetryClient } from './telemetryClient';

/** Live activity feed, console logs, and sparse toasts. */
export default function useLiveEvents() {
  var client = getTelemetryClient();
  var _state = useState(function () {
    return client.getState();
  });
  var state = _state[0];
  var setState = _state[1];

  useEffect(function () {
    return client.subscribe(setState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    events: state.events,
    logs: state.logs,
    toasts: state.toasts,
    clearLogs: function () {
      client.clearLogs();
    },
    dismissToast: function (id) {
      client.dismissToast(id);
    },
  };
}
